import classes from "./Loader.module.css";

const Loader = () => {
	return <div className={classes.coverSpin}></div>;
};

export default Loader;
